<template>
    <div>
        <div class="card">
            <div class="card__title">
                <h5>Imprimir</h5>
                <div class="card__controls">
                    <button @click="imprimir" class="btn-success" type="button"><i class="fa fa-print"></i> <span>Imprimir</span></button>
                </div>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-field">
                            <p>
                                <label for="a4">
                                    <input v-model="tipoImpresion" type="radio" id="a4" value="a4"> <span>Formato A4</span>
                                </label>
                            </p>
                        </div>
                        <div class="form-field">
                            <p>
                                <label for="puntoVenta">
                                    <input v-model="tipoImpresion" type="radio" id="puntoVenta" value="PV"> <span>Formato punto de venta</span>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        id_comprobante : {
            type : String, 
            required : true
        }
    },
    data : function () {
        return {
            url : url,
            tipoImpresion : 'a4'
        }
    },
    methods : {
        imprimir : function () {
            window.open(this.url + '/comprobantes/' + this.id_comprobante + '/ride?tipo_impresion=' + this.tipoImpresion, '_blank');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Imprimir.vue